/* oxlint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config file > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/
import iconSet from 'quasar/icon-set/material-symbols-rounded.js'

import {QSpinnerGears,Dialog,Loading,Meta,Notify} from 'quasar'

const userOptions = { config: {"loading":{"spinner":"QSpinnerGears"},"brand":{"default":"#222222","primary":"#0827f5","secondary":"#041375","accent":"#ffb700","hint":"#727272","positive":"#1fca2A","negative":"#ff2D27","info":"#03abf4","warning":"#ff8700"}},iconSet,components: {QSpinnerGears},plugins: {Dialog,Loading,Meta,Notify} }
userOptions.config.loading.spinner = QSpinnerGears

export default userOptions
